import React from 'react';
import { ImCheckboxChecked, ImCheckboxUnchecked } from 'react-icons/im';
import { Box, GridItem, HStack, Icon, Stack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CypressIds } from '../../../../../../../../../../../constants/cypressIds';
import { Statuses } from '../../../../../../../../../../../constants/statuses';

import LimitTooltip from './LimitTooltip';

const PolicyLimitsOptionsGrid = ({ limits }) => (
  <GridItem max colSpan={1} minW={250} rowSpan={1}>
    <Stack direction="column" spacing={1}>
      {
          limits.map(option => {
            const maxRequirement = parseInt(option.maxRequirement, 10) || 0;
            const submittedValue = parseInt(option.value, 10) || 0;

            if (maxRequirement || submittedValue) {
              const satisfied = submittedValue >= maxRequirement;
              const icon = satisfied ? ImCheckboxChecked : ImCheckboxUnchecked;
              const label = maxRequirement ? 'Required' : 'Not Required';

              return (
                <HStack
                  key={`${option.insurancePolicyTypePropertyId}`}
                  minWidth={200}
                  whiteSpace="nowrap"
                >
                  <Icon aria-label="sorted descending" as={icon} />
                  <LimitTooltip
                    limitName={option.insurancePolicyTypeProperty.displayName}
                    requiredText={label}
                  >
                    <Box
                      cursor="pointer"
                      data-cy={CypressIds.policyTypePropertyOption(option.insurancePolicyTypePropertyId, satisfied ? Statuses.Compliant : Statuses.NonCompliant)}
                      fontSize="xs"
                      overflow="hidden"
                      pl={0}
                      textAlign="left"
                      textOverflow="ellipsis"
                      whiteSpace="nowrap"
                    >
                      {option.insurancePolicyTypeProperty.displayName}
                    </Box>
                  </LimitTooltip>
                </HStack>
              );
            }
          })
        }
    </Stack>
  </GridItem>
);

PolicyLimitsOptionsGrid.propTypes = {
  limits: PropTypes.arrayOf(PropTypes.shape({
    maxRequirement: PropTypes.number,
    value: PropTypes.number,
    insurancePolicyTypePropertyId: PropTypes.number,
    insurancePolicyTypeProperty: PropTypes.shape({ displayName: PropTypes.string })
  }))
};

export default PolicyLimitsOptionsGrid;
